import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmConfirmClickedPayload {
  candidateId?: string;
  candidateCount: number;
}

/**
 * Fires when the user clicks "Confirm" on the bulk "Confirm Shifts" page.
 * Event: dental_portal:bulk_confirm:confirm_clicked
 */
export function fireBulkConfirmConfirmClicked(
  payload: IBulkConfirmConfirmClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:confirm_clicked', {
    candidate_id: payload.candidateId,
    candidate_count: payload.candidateCount,
  });
}
